import React from 'react';
import PropTypes from 'prop-types';
import { Button, Modal } from 'react-bootstrap-5';

export function DeleteReviewConfirmModal({ show, onCancel, onConfirm }) {
  return (
    <Modal show={show} onHide={onCancel}>
      <Modal.Header closeButton>
        <Modal.Title>Delete this review?</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        This review will be deleted. Any extracted data won&apos;t be saved.
      </Modal.Body>
      <Modal.Footer>
        <Button variant="link" onClick={onCancel}>Cancel</Button>
        <Button variant="danger" onClick={onConfirm}>Delete Review</Button>
      </Modal.Footer>
    </Modal>
  );
}

DeleteReviewConfirmModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};
